var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilding = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.9999H34.5V32.9999H1.5V29.9999H4.5V4.49988C4.5 4.10205 4.65804 3.72052 4.93934 3.43922C5.22064 3.15791 5.60218 2.99988 6 2.99988H30C30.3978 2.99988 30.7794 3.15791 31.0607 3.43922C31.342 3.72052 31.5 4.10205 31.5 4.49988V29.9999ZM12 16.4999V19.4999H16.5V16.4999H12ZM12 10.4999V13.4999H16.5V10.4999H12ZM12 22.4999V25.4999H16.5V22.4999H12ZM19.5 22.4999V25.4999H24V22.4999H19.5ZM19.5 16.4999V19.4999H24V16.4999H19.5ZM19.5 10.4999V13.4999H24V10.4999H19.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building.27d7b34b79dd104bf5ddd7e123a33d99.svg";